import _ from 'lodash';
import React from 'react';
import { Modal, Button } from 'react-bootstrap-old';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

const propTypes = {
  children: PropTypes.element,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  title: PropTypes.string,
  size: PropTypes.string,
  message: PropTypes.string,
  infoMessage: PropTypes.node,
  className: PropTypes.string,
  shouldConfirmClose: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  okBtnTitle: PropTypes.string,
  onCancel: PropTypes.func,
  cancelBtnTitle: PropTypes.string,
  btnClassName: PropTypes.string,
  backdrop: PropTypes.string,
  onSaveid: PropTypes.string,
  modalSaveButtonProps: PropTypes.shape({}),
  isOkBtnDisabled: PropTypes.bool,
  shouldShow: PropTypes.bool,
};
const defaultProps = {
  children: null,
  onSave: null,
  title: '',
  okBtnTitle: 'Save',
  size: '',
  message: null,
  infoMessage: null,
  className: '',
  onClose: _.noop,
  shouldConfirmClose: false,
  onCancel: null,
  cancelBtnTitle: 'Cancel',
  btnClassName: '',
  backdrop: '',
  onSaveid: '',
  modalSaveButtonProps: {},
  isOkBtnDisabled: false,
  shouldShow: true,
};

export default class ModalComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isClosing: false };
  }

  onHide = () => {
    const { onClose, shouldConfirmClose } = this.props;

    if (_.isFunction(shouldConfirmClose) ? shouldConfirmClose() : shouldConfirmClose) {
      this.setState({ isClosing: true });
    } else {
      onClose();
    }
  };

  onConfirmedClose = () => {
    const { onClose } = this.props;

    this.setState({ isClosing: false });
    onClose();
  };

  renderCloseConfirmation = () => (
    <>
      <div className="modal-body confirmation-modal-body">
        <figure />
        <div className="confirmation-window text-center">
          <h5 className="tx-22">Confirmation</h5>
          <i className="fa-regular fa-circle-info tx-30 mb-3 mt-3 "></i>
          <p className="m-0">Are you sure to close without saving</p>
        </div>
      </div>

      <div className="modal-footer d-flex align-items-center flex-nowrap confirmation-modal-footer">
        <button
          type="button"
          className="btn btn-outline-primary btn-block me-2"
          onClick={this.onConfirmedClose}
        >
          Yes
        </button>

        <button
          type="button"
          autoFocus
          className="btn btn-primary btn-block m-0"
          onClick={() => this.setState({ isClosing: false })}
        >
          No
        </button>
      </div>
    </>
  );

  render() {
    const {
      children,
      title,
      onSave,
      size,
      className,
      okBtnTitle,
      btnClassName,
      message,
      infoMessage,
      onCancel,
      cancelBtnTitle,
      backdrop,
      onSaveid,
      modalSaveButtonProps,
      isOkBtnDisabled,
      shouldShow,
    } = this.props;
    const { isClosing } = this.state;

    let modalProps = {
      size: isClosing ? 'sm' : size,
      show: shouldShow,
      onHide: this.onHide,
      className: `${className} ${isClosing ? 'confirmation-modal' : ''}`,
      centered: true,
      'aria-labelledby': 'contained-modal-title-vcenter',
    };

    if (backdrop) modalProps = { ...modalProps, backdrop };

    const renderModalFooter = () => {
      const isShow = message || onSave || onCancel || infoMessage;
      if (!isShow) return null;

      return (
        <Modal.Footer>
          {infoMessage && <div className="alert alert-info p-1">{infoMessage}</div>}
          {message && <div className="alert alert-danger">{message}</div>}
          {onCancel && (
            <Button variant="outline-danger" onClick={onCancel}>
              {cancelBtnTitle}
            </Button>
          )}
          {onSave && (
            <Button
              {...modalSaveButtonProps}
              variant="primary"
              className={btnClassName}
              onClick={onSave}
              id={onSaveid}
              disabled={isOkBtnDisabled}
            >
              {okBtnTitle}
            </Button>
          )}
        </Modal.Footer>
      );
    };

    return (
      <Modal {...modalProps}>
        {isClosing ? (
          this.renderCloseConfirmation()
        ) : (
          <>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">{ReactHtmlParser(title)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{children}</Modal.Body>
            {renderModalFooter()}
          </>
        )}
      </Modal>
    );
  }
}

ModalComponent.propTypes = propTypes;
ModalComponent.defaultProps = defaultProps;
